/* file description */

import { CSSProperties, useEffect, useRef, useState } from "react"


export const useScale = () => {
  const targetDomRef = useRef<HTMLDivElement>(null);
  const [scaleStyle, setScaleStyle] = useState<CSSProperties|undefined>((undefined))
  useEffect(()=>{
    // 自动缩放
    const targetPC = targetDomRef.current?.parentElement?.clientWidth;
    if(!targetPC){
      return ;
    }
    const targetW = targetDomRef.current?.scrollWidth || targetPC;
    let scale = targetPC/targetW;
    if(scale < 0.6) {
      scale = 0.6
    }
    const style = `scale(${scale})`;
    setScaleStyle({
      transform: style
    });
  }, [])

  return {
    scaleStyle,
    targetDomRef
  }
}